import { useSelectedLayoutSegments } from "next/navigation"

export const useHideNavigationLayoutComponents = () => {
  const segments = useSelectedLayoutSegments()
  return segments[0] === "(hidden-nav)"
}
